<template src="./template.html" ></template>

<script>
import MyAlert from '../../components/alert/MyAlert.vue'
import MyListButtons from '../add/Buttons.vue'
import MyNumber from '../../components/MyNumber.vue'
import MyFloat from '../../components/MyFloat.vue'
import MyCurrency from '../../components/MyCurrency.vue'
import MygProducts from './MygProducts.vue'
import MyComment from '../../components/MyComment.vue'

export default {
  name: 'product-items',
  props: ['formTitle'],
  data() {
    return {
      valid: false,
      alert: false,
      model: {
        unit_type: "1",
        init: {
          items: {
            //     price: null
          }
        }
      },
      requiredRules: [
        v => !!v || 'فیلد اجباری',
      ],
      gtZeroRules: [
        v => !!v || 'فیلد اجباری',
        v => (v && this.rmCamma(v) > 0) || 'فیلد اجباری'
      ],
    }
  },
  async beforeCreate() {
    this.formState = this.$router.currentRoute.path.split("/")[2]
    this.route = this.$store.getters.pageInfo.route
    if (this.formState === 'edit') {
      let _mid = this.$router.currentRoute.path.split("/")[3]
      let data = {
        url: `/api/${this.route}`,
        params: {
          mid: _mid
        },
      }
      await this.$store.dispatch('getInfo', data)
      this.model = this.$store.getters.editData
      // console.log(this.model);
    }
  },
  methods: {
    async onSave() {
      //
      let _method = 'POST'
      if (this.formState === 'edit') {
        _method = 'PUT'
      }
      this.$refs.form.validate()
      let _data = {
        method: _method,
        url: `/api/${this.route}`,
        data: {
          data: this.model
        },
      }
      if (this.valid) {
        await this.$store.dispatch('save', _data)
        let res = this.$store.getters.saveData
        // console.log(res);
        if (res && (res.insert || res.update)) {
          this.alert = true
        }
      }
    },
    onChangeUnitType(e) {
      if (e == 1) {
        this.model.unit2 = null,
          this.model.n = 0
      }
    },
    cpAlias() {
      if (!this.model.alias && this.model.title) {
        this.model.alias = this.model.title
      }
    },
  },
  components: {
    MyAlert,
    MyListButtons,
    MyNumber,
    MyFloat,
    MyCurrency,
    MygProducts,
    MyComment,
  },
}
</script>
<style lang="scss">
</style>
